import { render, staticRenderFns } from "./PastaPage.vue?vue&type=template&id=6da94390&scoped=true&"
import script from "./PastaPage.vue?vue&type=script&lang=js&"
export * from "./PastaPage.vue?vue&type=script&lang=js&"
import style0 from "./PastaPage.vue?vue&type=style&index=0&id=6da94390&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da94390",
  null
  
)

export default component.exports